import request from "../../request.js"
import URL from "../../url/search/index.js"
import CONFIG from "../../../utils/config.js"
class Search{
  //搜索结果
  static storyList({
    sortOrderOptions=0,
    matchingConditionOptions=0,
    storyType=0,
    keywordWay,
    channelId,
    page,
    searchKeyword,
    duplication="off",
    exColumns="",
    size=10
  }){
    var storyTypeStr = ""
    //设置稿件类型
    switch(storyType){
      case 0:{
        storyTypeStr = "&typeSearch=all"
        break;
      }
      case 1:{
        storyTypeStr = "&typeSearch=immed"
        channelId = "tkww"
        break;
      }
      case 2:{
        storyTypeStr = "&typeSearch=epaper"
        channelId = "tkww"
        break;
      }
      case 3:{
        storyTypeStr = "&typeSearch=gallery"
        channelId = "tkww"
        break;
      }
      case 4:{
        storyTypeStr = "&typeSearch=video"
        channelId = "tkww"
        break;
      }
      case 5:{
        break;
      }
    }
    var url = `${URL.TKWW_SEARCH}?channel=${channelId}&page=${page}${storyTypeStr}`
    if(duplication){
      url += `&duplication=${duplication}`
    }
    //设置排序方式
    switch(sortOrderOptions){
      case 0:{
        url += "&order=desc&sort=publishTime"
        break;
      }
      case 1:{
        url += "&order=asc&sort=publishTime"
        break;
      }
    }
    //设置搜全文
    switch(matchingConditionOptions){
      case 0:{
        url += `&fullMust=${searchKeyword}`
        break;
      }
      case 1:{
        url += `&titleMust=${searchKeyword}`
        break;
      }
      case 2:{
        url += `&onlyKeyword=${searchKeyword}`
        break;
      }
      case 3:{
        break;
      }
    }
    //tag标签检索
    if(keywordWay=="tag"){
      url = `${URL.TKWW_SEARCH}?channel=${channelId}&page=${page}&order=desc&sort=publishTime&tag=${searchKeyword}`
    }
    if(size){
      url += `&size=${size}`
    }
    if(exColumns){
      url += `&exColumns=${exColumns}`
    }
    const res = request.get({
      url,
      config: {
        baseURL: CONFIG.BASE_SEARCH_URL,
        common: {
          useToken: false
        }
      }
    })
    return res
  }
  static dateStoryList({channelId,columnId,dateVal,page,includeSubColumn,sortOrderOptions,size=10}){
    var url = "channels/"+ channelId +"/columns/"+ columnId +"/date/stories.json?publishTime=" + dateVal + "&page=" +page+ "&size="+size;
    if(includeSubColumn)url += `&includeSubColumn=${includeSubColumn}`
    //设置排序方式
    switch(sortOrderOptions){
      case 0:{
        url += "&order=desc"
        break;
      }
      case 1:{
        url += "&order=asc"
        break;
      }
      case 2:{
        url += "&order=score"
        break;
      }
    }
    const res = request.get({
      url,
      config: {
        //baseURL: CONFIG.BASE_EPAPER_URL,
        common: {
          useToken: false
        }
      }
    })
    return res
  }
  static getRestList({channel='tkww',page=0,size=15,mode='json',order='desc',tag='',typeNot='VIDEO,INNERLINK',typeMust=''}){
    var url = `${URL.REST_SEARCH}?channel=${channel}&page=${page}&size=${size}&mode=${mode}&order=${order}&tag=${tag}`
    if(typeNot!==""){
      url += `&typeNot=${typeNot}`
    }
    if(typeMust!==""){
      url += `&typeMust=${typeMust}`
    }
    const res = request.get({
      url,
      config: {
        baseURL: CONFIG.BASE_SEARCH_URL,
        common: {
          useToken: false
        }
      }
    })
    return res
  }
  static getTopWords(){
    var url = URL.TOP_WORDS
    const res = request.get({
      url,
      config: {
        baseURL: CONFIG.BASE_SEARCH_URL,
        common: {
          useToken: false
        }
      }
    })
    return res
  }
  static getTimeList({channel="tkww",keyword="",page=0,size=10,publishedDateFrom="",publishedDateTo=""}){
    var url = `${URL.TIME_LIST}?channel=${channel}&keyword=${keyword}&page=${page}&size=${size}`
    if(publishedDateFrom!==""){
      url += `&publishedDateFrom=${publishedDateFrom}`
    }
    if(publishedDateTo!==""){
      url += `&publishedDateTo=${publishedDateTo}`
    }
    const res = request.get({
      url,
      config: {
        baseURL: CONFIG.BASE_SEARCH_URL,
        common: {
          useToken: false
        }
      }
    })
    return res
  }
}

export default Search